import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Divider,
  Drawer,
  Grid,
  Hidden,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Button,
  Modal,
  withStyles,
  Switch,
  Backdrop,
  Fade
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { ArrowBack, Menu as MenuIcon, InboxOutlined, ExpandMore, ExpandLess } from '@material-ui/icons';
import FlechaIzquierda from './img/Flecha_izquierda.svg';
import PaymentTable from './PaymentTable';
import iconModal from './img/iconModal.png';
import Footer from './Footer';
import FooterMobile from './FooterMobile';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { paymentRequestAgent, resetPaymentLoading } from '../../../../redux/actions/agentActions';
import get from 'lodash/get';
import { isMobile } from 'react-device-detect';
import LoadingButton from '../../../../components/LoadingButton';

const catalogErrors = {
  'The currency of a receipt does not correspond.': 'La moneda de un recibo no corresponde.',
  'Receipts does not exist.': 'Los recibos no existen.',
  'Some receipts does not exists.': 'Algunos recibos no existen.',
  'Some receipts is already paid.': 'Algunos recibos ya fueron pagados.',
  'Some receipts is already canceled.': 'Algunos recibos ya fueron cancelados.',
  'Some receipts have expired.': 'Algunos recibos han expirado.',
  'The total of some receipts does not correspond to the total.': 'El total de algunos recibos no corresponde al total.',
  'You cannot pay a domicilied policy.': 'El recibo de la póliza seleccionada se encuentra domiciliado. Para poder realizar el cobro en línea es necesario desactivar dicha domiciliación y evitar duplicidad de cobro por el proceso automático.'
};

const dynamicErrorPatterns = [
  {
    pattern: /^No se puede pagar la factura \d+ porque la factura anterior \d+ no ha sido pagada$/,
    useOriginal: true
  }
];

const getErrorMessage = errorMessage => {
  if (catalogErrors[errorMessage]) {
    return catalogErrors[errorMessage];
  }
  for (const errorPattern of dynamicErrorPatterns) {
    if (errorPattern.pattern.test(errorMessage)) {
      return errorPattern.useOriginal ? errorMessage : errorPattern.translation;
    }
  }
  return 'La página no se encuentra disponible. Inténtelo más tarde.';
};

const drawerWidth = 240;

const ToggleSwitchText = withStyles(theme => ({
  switchBase: {
    '&$checked': {
      color: theme.palette.primary.main
    },
    '&$checked + $track': {
      backgroundColor: theme.palette.primary.main
    }
  },
  checked: {},
  track: {
    backgroundColor: theme.palette.grey[400],
    borderRadius: 20
  },
  thumb: {
    width: 70,
    height: 34,
    backgroundColor: '#ffffff',
    borderRadius: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    color: theme.palette.primary.main
  },
  root: {
    width: 140,
    height: 34,
    padding: 0,
    display: 'flex'
  }
}))(Switch);

const styles = theme => ({
  menuButton: {
    marginRight: 20,
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  buttonPrimary: {
    width: '117px',
    height: '40px',
    background: '#0133A0',
    borderRadius: '20px',
    color: '#FFFFFF',
    fontFamily: 'Sura Sans',
    fontSize: '14px'
  },
  buttonSecondary: {
    width: '117px',
    height: '40px',
    background: '#E3E828',
    borderRadius: '20px',
    color: '#0133A0',
    fontFamily: 'Sura Sans',
    fontSize: '14px'
  },
  modal: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '391px',
    height: '303px',
    backgroundColor: '#FFF',
    borderRadius: '10px',
    padding: '8px 30px',
    boxShadow: theme.shadows[5],
    outline: 'none',
    marginTop: '20%'
  },
  toolbar: theme.mixins.toolbar,
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
      position: 'relative'
    }
  }
});

const PaymentSummary = props => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { classes, selectedData, paymentRequestAgent, resetPaymentLoading, paymentToken, currency, loading, errorPaymentRequest } = props;
  const [checked, setChecked] = useState(false);
  const [confirmUsd, setConfirmUsd] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [expandedPolicies, setExpandedPolicies] = useState({});
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    resetPaymentLoading();
  }, [resetPaymentLoading]);

  const handleToggle = () => {
    setChecked(!checked);
  };

  const handleExpandClick = () => {
    history.push(`/cobranza/agente`);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleExpand = policyId => {
    setExpandedPolicies(prevState => ({
      ...prevState,
      [policyId]: !prevState[policyId]
    }));
  };

  const hasUSD = selectedData.filter(item => typeof item === 'object').every(item => item.currency === 'USD') && selectedData.length > 0;
  const calculateRawTotalSum = () => {
    return selectedData.reduce((acc, item) => {
      const totalInSelectedCurrency = hasUSD
        ? checked
          ? parseFloat(item.totalm * props.currency)
          : parseFloat(item.total)
        : parseFloat(item.total);
      return acc + totalInSelectedCurrency;
    }, 0);
  };

  const calculateTotalSum = () => {
    const sum = selectedData
      .filter(item => typeof item === 'object')
      .reduce((acc, item) => {
        const totalInSelectedCurrency = hasUSD
          ? checked
            ? parseFloat(item.total * props.currency)
            : parseFloat(item.total)
          : ['MXP', 'MXN'].includes(item.currency)
          ? parseFloat(item.total)
          : parseFloat(item.total * props.currency);

        return acc + totalInSelectedCurrency;
      }, 0);

    return sum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const policyData = selectedData
    .filter(item => typeof item === 'object')
    .reduce((acc, item) => {
      const policyId = `${item.office_id} - ${item.product_id} - ${item.policy_id}`;

      if (!acc[policyId]) {
        acc[policyId] = { receipts: [], solution: item.solution, policy_master_id: item.policy_master_id || null };
      }

      const totalInSelectedCurrency =
        hasUSD && !checked ? item.total : !hasUSD && ['MXP', 'MXN'].includes(item.currency) ? item.total : item.total * props.currency;

      acc[policyId].receipts.push({
        invoice: item.invoice,
        total: totalInSelectedCurrency
      });

      return acc;
    }, {});

  const groupedByMaster = Object.entries(policyData).reduce((acc, [policyId, data]) => {
    const masterKey = data.policy_master_id || '__no_master__';
    if (!acc[masterKey]) acc[masterKey] = [];
    acc[masterKey].push([policyId, data]);
    return acc;
  }, {});

  const handlePaymentRequestMXN = async () => {
    try {
      let json = {
        receipts: selectedData
          .filter(item => typeof item === 'object')
          .map(row => ({
            uuid: row.uuid,
            amount: parseFloat(row.total),
            currency_rate: ['MXP', 'MXN'].includes(row.currency) ? 1 : Number(currency)
          })),
        // Include token for backend to verify domiciliation permissions
        token: paymentToken
      };
      await paymentRequestAgent(paymentToken, json);
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 5000);
    } catch (error) {
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 5000);
      throw error;
    }
  };

  const handlePaymentRequestUSD = async () => {
    try {
      let json = {
        exchange_rate: {
          total_receipts: Number(calculateRawTotalSum()),
          currency_rate: Number(currency)
        },
        receipts: selectedData
          .filter(item => typeof item === 'object')
          .map(row => ({
            uuid: row.uuid,
            amount: parseFloat(row.total),
            currency_rate: ['MXP', 'MXN'].includes(row.currency) ? 1 : Number(currency)
          })),
        // Include token for backend to verify domiciliation permissions
        token: paymentToken
      };
      await paymentRequestAgent(paymentToken, json);
    } catch (error) {
      throw error;
    }
  };

  const handlePaymentRequest = async () => {
    try {
      if (hasUSD) {
        if (checked) {
          await handlePaymentRequestMXN();
        } else {
          setOpenModal(true);
        }
      } else {
        await handlePaymentRequestMXN();
      }
    } catch (error) {
      console.error('Error en handlePaymentRequest:', error);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  return (
    <React.Fragment>
      <div
        style={{
          background: '#FFF',
          padding: isMobile ? '30px 8% 50px' : '30px 30px 50px ',
          borderTop: '1px solid #D9D9D9',
          maxWidth: '1440px',
          margin: '0 auto'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'flex-start' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              paddingRight: isMobile ? '0' : '25px',
              width: '100%'
            }}
          >
            <Grid
              container
              alignItems="center"
              justify="space-between"
              style={{ gap: '10px', marginTop: isMobile ? '50px' : '0' }}
            >
              <div
                style={{
                  width: '105px',
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '5px',
                  alignItems: 'center'
                }}
              >
                <IconButton onClick={() => handleExpandClick()} style={{ paddingRight: 0 }}>
                  <img src={FlechaIzquierda} />
                </IconButton>
                <Typography
                  style={{
                    color: '#2D6DF6',
                    fontSize: '16px',
                    fontWeight: '500',
                    fontFamily: 'Sura Sans',
                    cursor: 'pointer'
                  }}
                  onClick={() => handleExpandClick()}
                >
                  Atrás
                </Typography>
              </div>
              <Button 
                size="medium" 
                className={classes.buttonSecondary} 
                onClick={() => handlePaymentRequest()}
                disabled={loading}
                style={{
                  cursor: loading ? 'not-allowed' : 'pointer',
                  pointerEvents: loading ? 'none' : 'auto',
                  opacity: loading ? 0.7 : 1
                }}
              >
                <LoadingButton isLoading={loading}  placeholder='Continuar' btnTextColor='#0133A0' />
              </Button>
            </Grid>
            {isMobile && (
              <div
                style={{
                  width: '100%',
                  minHeight: '112px',
                  borderRadius: '8px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  paddingTop: '15px',
                  gap: '10px',
                  alignItems: 'center',
                  background: '#2D6DF6',
                  margin: '10px 0',
                  padding: '15px'
                }}
              >
                <Typography style={{ color: '#FFFFFF', fontSize: '28px', fontFamily: 'Sura Sans', fontWeight: '700' }}>
                  {calculateTotalSum()}
                </Typography>
                <Typography style={{ color: '#FFFFFF', fontSize: '12px', fontFamily: 'Sura Sans', fontWeight: '500' }}>
                  TOTAL A PAGAR {!hasUSD || (hasUSD && checked) ? 'MXN' : 'USD'}
                </Typography>
                {hasUSD && (
                  <div
                    style={{
                      display: 'flex',
                      height: '53px',
                      width: '100%',
                      background: '#0033A0',
                      borderRadius: '10px',
                      padding: '7px 20px 7px 17px',
                      alignItems: 'center',
                      margin: '15px 0',
                      justifyContent: 'space-between'
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography style={{ color: '#FFFFFF', fontSize: '16px', fontFamily: 'Sura Sans' }}>
                        {currency}
                      </Typography>
                      <Typography style={{ color: '#FFFFFF', fontSize: '14px', fontFamily: 'Sura Sans' }}>
                        Tipo de cambio:
                      </Typography>
                    </div>
                    <div
                      onClick={handleToggle}
                      style={{
                        width: '62px',
                        height: '24px',
                        borderRadius: '12px',
                        backgroundColor: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: checked ? 'flex-end' : 'flex-start',
                        padding: '5px',
                        cursor: 'pointer',
                        border: '1px solid #2D6DF6',
                        position: 'relative'
                      }}
                    >
                      <div
                        style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '15px',
                          backgroundColor: '#2D6DF6',
                          position: 'absolute',
                          left: checked ? '38px' : '2px',
                          transition: 'left 0.3s'
                        }}
                      />
                      <span
                        style={{
                          color: '#2D6DF6',
                          fontSize: '14px',
                          position: 'absolute',
                          left: checked ? '5px' : '25px',
                          transition: 'left 0.3s'
                        }}
                      >
                        {!hasUSD || (hasUSD && checked) ? 'MXN' : 'USD'}
                      </span>
                    </div>
                  </div>
                )}
                {Object.entries(groupedByMaster).map(([masterKey, policies]) => (
                  <React.Fragment key={masterKey}>
                    {masterKey !== '__no_master__' && (
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          borderRadius: '12px',
                          padding: '10px 10px 0',
                          marginTop: '10px'
                        }}
                      >
                        <Typography style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#FFFFFF', fontWeight: 600 }}>
                          Póliza maestra:
                        </Typography>
                        <Typography style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#FFFFFF' }}>
                          {masterKey}
                        </Typography>
                      </div>
                    )}
                    {policies.map(([policyId, data]) => (
                      <div
                        key={policyId}
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          borderRadius: '12px',
                          padding: '10px',
                          marginTop: '10px',
                          border: '1px solid #81B1FF'
                        }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#FFFFFF' }}>
                            Póliza: {policyId}
                          </Typography>
                          <div
                            onClick={() => toggleExpand(policyId)}
                            style={{
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            {expandedPolicies[policyId] ? (
                              <ExpandLess style={{ color: '#FFFFFF' }} />
                            ) : (
                              <ExpandMore style={{ color: '#FFFFFF' }} />
                            )}
                          </div>
                        </div>
                        <Typography
                          style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#FFFFFF', marginBottom: '10px' }}
                        >
                          {data.solution}
                        </Typography>
                        {expandedPolicies[policyId] &&
                          data.receipts.map((receipt, index) => (
                            <div
                              key={index}
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                margin: '5px 0'
                              }}
                            >
                              <Typography
                                style={{ fontSize: '11px', fontWeight: '400', fontFamily: 'Sura Sans', color: '#FFFFFF' }}
                              >
                                Recibo: {receipt.invoice}
                              </Typography>
                              <Typography style={{ fontSize: '13px', fontFamily: 'Sura Sans', color: '#FFFFFF' }}>
                                {`$${parseFloat(receipt.total || 0)
                                  .toFixed(2)
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                              </Typography>
                            </div>
                          ))}
                      </div>
                    ))}
                  </React.Fragment>
                ))}
              </div>
            )}
            <Typography
              style={{
                color: '#000000',
                fontSize: '26px',
                fontWeight: '600',
                fontFamily: 'Sura Sans'
              }}
            >
              Resumen de recibos seleccionados para pago
            </Typography>
            {!isLoading && (
              <PaymentTable
                setIsLoading={setIsLoading}
                withCheckbox={false}
                isPending={false}
                withActions={true}
                isDataComplete={true}
                type="summary"
              />
            )}
          </div>
          {!isMobile && (
            <div
              style={{
                minWidth: '264px',
                minHeight: '111px',
                background: '#2D6DF6',
                borderRadius: '20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px'
              }}
            >
              <Typography style={{ color: '#FFFFFF', fontSize: '22px', fontFamily: 'Sura Sans' }}>
                {calculateTotalSum()}
              </Typography>
              <Typography style={{ color: '#FFFFFF', fontSize: '12px', fontFamily: 'Sura Sans' }}>
                TOTAL A PAGAR {!hasUSD || (hasUSD && checked) ? 'MXN' : 'USD'}
              </Typography>
              {hasUSD &&(
                <div
                  style={{
                    display: 'flex',
                    height: '53px',
                    width: '100%',
                    background: '#0033A0',
                    borderRadius: '10px',
                    padding: '7px 20px 7px 17px',
                    alignItems: 'center',
                    margin: '15px 0',
                    justifyContent: 'space-between'
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography style={{ color: '#FFFFFF', fontSize: '16px', fontFamily: 'Sura Sans' }}>
                      {currency}
                    </Typography>
                    <Typography style={{ color: '#FFFFFF', fontSize: '14px', fontFamily: 'Sura Sans' }}>
                      Tipo de cambio:
                    </Typography>
                  </div>
                  <div
                    onClick={handleToggle}
                    style={{
                      width: '62px',
                      height: '24px',
                      borderRadius: '12px',
                      backgroundColor: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: checked ? 'flex-end' : 'flex-start',
                      padding: '5px',
                      cursor: 'pointer',
                      border: '1px solid #2D6DF6',
                      position: 'relative'
                    }}
                  >
                    <div
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '15px',
                        backgroundColor: '#2D6DF6',
                        position: 'absolute',
                        left: checked ? '38px' : '2px',
                        transition: 'left 0.3s'
                      }}
                    />
                    <span
                      style={{
                        color: '#2D6DF6',
                        fontSize: '14px',
                        position: 'absolute',
                        left: checked ? '5px' : '25px',
                        transition: 'left 0.3s'
                      }}
                    >
                      {!hasUSD || (hasUSD && checked) ? 'MXN' : 'USD'}
                    </span>
                  </div>
                </div>
              )}
              {Object.entries(groupedByMaster).map(([masterKey, policies]) => (
                <React.Fragment key={masterKey}>
                  {masterKey !== '__no_master__' && (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '12px',
                        padding: '10px 10px 0',
                        marginTop: '10px'
                      }}
                    >
                      <Typography style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#FFFFFF', fontWeight: 600 }}>
                        Póliza maestra:
                      </Typography>
                      <Typography style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#FFFFFF' }}>
                        {masterKey}
                      </Typography>
                    </div>
                  )}
                  {policies.map(([policyId, data]) => (
                    <div
                      key={policyId}
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '12px',
                        padding: '10px',
                        marginTop: '10px',
                        border: '1px solid #81B1FF'
                      }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#FFFFFF' }}>
                          Póliza: {policyId}
                        </Typography>
                        <div
                          onClick={() => toggleExpand(policyId)}
                          style={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          {expandedPolicies[policyId] ? (
                            <ExpandLess style={{ color: '#FFFFFF' }} />
                          ) : (
                            <ExpandMore style={{ color: '#FFFFFF' }} />
                          )}
                        </div>
                      </div>
                      <Typography
                        style={{ fontSize: '14px', fontFamily: 'Sura Sans', color: '#FFFFFF', marginBottom: '10px' }}
                      >
                        {data.solution}
                      </Typography>
                      {expandedPolicies[policyId] &&
                        data.receipts.map((receipt, index) => (
                          <div
                            key={index}
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              margin: '5px 0'
                            }}
                          >
                            <Typography
                              style={{ fontSize: '11px', fontWeight: '400', fontFamily: 'Sura Sans', color: '#FFFFFF' }}
                            >
                              Recibo: {receipt.invoice}
                            </Typography>
                            <Typography style={{ fontSize: '13px', fontFamily: 'Sura Sans', color: '#FFFFFF' }}>
                              {`$${parseFloat(receipt.total || 0)
                                .toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                            </Typography>
                          </div>
                        ))}
                    </div>
                  ))}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </div>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        className={classes.modal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={openModal}>
          <div className={classes.modalContent}>
            <img src={iconModal} className="iconlogoModal" />
            <Typography
              style={{
                fontFamily: 'Sura Sans',
                fontSize: '22px',
                color: '#0033A0',
                fontWeight: '600',
                textAlign: 'center',
                marginTop: '10px'
              }}
            >
              Pago en dólares
            </Typography>
            <span style={{ fontFamily: 'Sura Sans', fontSize: '16px', color: '#0033A0', marginTop: '10px' }}>
              El pago en Dólares solo podrá ser realizado por{' '}
              <span style={{ fontFamily: 'Sura Sans', fontSize: '16px', color: '#0033A0', fontWeight: '600' }}>
                referencia bancaria
              </span>
            </span>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1.2rem', marginTop: '1.5rem' }}>
              <Button
                onClick={handleCloseModal}
                disabled={loading}
                style={{ 
                  width: '100px', 
                  height: '40px', 
                  border: '1px solid #0133A0', 
                  borderRadius: '28px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1
                }}
              >
                Cancelar
              </Button>
              <Button
                onClick={async () => {
                  setOpenModal(false);
                  try {
                    await handlePaymentRequestUSD();
                  } catch (error) {
                    console.error('Error en pago USD:', error);
                  }
                }}
                disabled={loading}
                style={{ 
                  width: '92px', 
                  height: '40px', 
                  border: '1px solid #0133A0', 
                  borderRadius: '28px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  pointerEvents: loading ? 'none' : 'auto',
                  opacity: loading ? 0.7 : 1
                }}
              >
                {loading ? 'Procesando...' : 'Aceptar'}
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>

      {isMobile && <FooterMobile />}
      {!isMobile && <Footer />}
      <div
        className={`toast ${(showToast && errorPaymentRequest) ? 'show' : ''}`}
        style={{
          visibility: (showToast && errorPaymentRequest) ? 'visible' : 'hidden',
          minWidth: '800px',
          backgroundColor: '#F4C7C7',
          color: 'red',
          textAlign: 'center',
          borderRadius: '10px',
          padding: '16px',
          position: 'fixed',
          zIndex: 1000,
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: '60px',
          fontSize: '17px',
          opacity: (showToast && errorPaymentRequest) ? 1 : 0,
          transition: 'opacity 0.6s, visibility 0.6s',
          border: '1px solid red' 
        }}
      >
        {getErrorMessage(errorPaymentRequest)}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  selectedData: get(state, 'agentReducer.selected'),
  paymentToken: state.agentReducer.paymentToken,
  currency: state.agentReducer.currency,
  loading: state.agentReducer.loading,
  errorPaymentRequest: state.agentReducer.errorPaymentRequest,
});

const mapDispatchToProps = {
  paymentRequestAgent,
  resetPaymentLoading
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles, { withTheme: true })
)(PaymentSummary);


// WEBPACK FOOTER //
// ./src/containers/agent/Tabs/Payments/PaymentSummary.js